import { get, post, patch, destroy } from './httpClient'

export const getSetMenu = (query) => get('/set-menu', query)
export const addSetMenu = (body) => post('/set-menu/create', body)
export const updateSetMenu = (id, body) => patch('/set-menu/update/' + id, body)
export const deleteSetMenu = (ids) => destroy('/set-menu/delete', { product_id: ids })